import PropTypes from 'prop-types';

import { IconCTA, OverlayTriggerTooltip, RepromptIcon } from '@utilities';

const Reprompt = ({
  canReprompt,
  handleReprompt,
  hasException,
  hasExpiration,
  isHoverAction,
  selectedRows,
}) => {
  const isVisible =
    selectedRows.length === 1 && (canReprompt || handleReprompt) && !hasException && !hasExpiration;

  if (!isVisible) return null;

  return (
    <OverlayTriggerTooltip content={isHoverAction ? 'Reprompt' : ''}>
      <IconCTA
        data-testid={handleReprompt ? 'reprompt-fast-track' : 'reprompt-cta'}
        icon={<RepromptIcon />}
        onClick={handleReprompt ? () => handleReprompt(selectedRows[0]) : undefined}
        path={
          !handleReprompt
            ? `/dashboard/create-report/${selectedRows[0]?.documentId}?job_id=${selectedRows[0]?.id}`
            : undefined
        }
        text={isHoverAction ? '' : 'Reprompt'}
      />
    </OverlayTriggerTooltip>
  );
};

Reprompt.propTypes = {
  canReprompt: PropTypes.bool,
  handleReprompt: PropTypes.func,
  hasException: PropTypes.bool,
  hasExpiration: PropTypes.bool,
  isHoverAction: PropTypes.bool,
  selectedRows: PropTypes.array,
};

export default Reprompt;
